import React from 'react';
import ReactDOM from 'react-dom/client';
import { createGlobalStyle } from 'styled-components';
import { createHashRouter, RouterProvider } from 'react-router-dom';
import Root from 'routes/Root';
import ErrorPage from 'routes/ErrorPage';
import WelcomePage from 'routes/WelcomePage';
import IntakePage from 'routes/IntakePage';
import ResultsPage from 'routes/ResultsPage';
import TransmittingPage from 'routes/TransmittingPage';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: AyeshaDisplay;
    src: url(${require('assets/font/AyeshaDisplay.ttf')});
  }

  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: Arial, sans-serif;
  }
`

const router = createHashRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <WelcomePage />
      },
      {
        path: '/intake',
        element: <IntakePage />
      },
      {
        path: '/transmitting',
        element: <TransmittingPage />
      },
      {
        path: '/results',
        element: <ResultsPage />
      }
    ]
  }
])
export const rootNode = document.getElementById('root');
const root = ReactDOM.createRoot(rootNode);
root.render(
  <React.StrictMode>
    <GlobalStyles />
    <RouterProvider router={router} />
  </React.StrictMode>
);
